var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlur02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1617 1111",
    width: 1617,
    height: 1111,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg_blur-02-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    id: "f1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-363.2,-883.976,1232.12,-506.242,1081,791.493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#860d1c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860d1c",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { filter: url(#f1);fill: url(#g1) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m150 555.5c0-224 294.8-405.5 658.5-405.5 363.7 0 658.5 181.5 658.5 405.5 0 224-294.8 405.5-658.5 405.5-363.7 0-658.5-181.5-658.5-405.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlur02);
export default __webpack_public_path__ + "static/media/bg_blur-02.5d2afaa7fab36ad1a4f4315b8c05cb45.svg";
export { ForwardRef as ReactComponent };